import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cookieDashboardButton: {
    id: `freeTextContent.cookieDashboardButton`,
    defaultMessage: 'Cookie Dashboard',
  },
});
